import { FreeGameViewBehavior, SlotConstantsBehavior, SlotEventConstantsBehavior } from "@quest/murka-games-behavior-leopard/dist";
import { ITween, SpineBase, ingenuity, Linear, IObject, Label, IEvent, dispatcher, Container, detectDeviceEnvironmentConstants as deviceEnvironment, detectDeviceEnvironmentConstants, Graphics } from "@quest/base-core";
import { ReelPanel, SlotConstants, StaticSymbol, SymbolBase } from "@quest/slot-core";
import { gameConstants } from "../Constants/gameConstants";
import { SoundConstantGame } from "../Constants/SoundConstantGame";
import { eventDispatchers } from "../Constants/EventDispatchers";




export class View extends FreeGameViewBehavior {

  private scatterSymbolCount: number = 0;
  private reelId_0: number = 0;
  private reelId_2: number = 2;
  private reelId_4: number = 4;
  private scatterSymbol_0: number = 0;
  private scatterSymbol_1: number = 1;
  private scatterSymbol_2: number = 2;
  private freeSpinsText: Label;
  private reelsContainerFg: Container;
  private baseGameMask: Graphics
  private fgHitAnimationContainer:Container
  /**
   * resize method overrided to update pivot in mobile
   */
  protected resize(e?: IObject): void {
    super.resize(e);
    this.fgHitAnimationContainer = this.getContainerByID("fgHitAnimationContainer");
    if (!ingenuity.deviceEnv.isDesktop) {
      this.pivot.set((ingenuity.configData.width * SlotConstantsBehavior.HALF_CONVERTER), (ingenuity.configData.height * SlotConstantsBehavior.HALF_CONVERTER));
    }
    // if (ingenuity.deviceEnv.isDesktop) {
      this.reelsContainerFg = this.getContainerByID("reelsContainerFg")
      if (this.reelsContainerFg) {
        this.baseGameMask = this.getShapeById("baseGameMask") as Graphics;
        (this.reelsContainerFg.mask as Graphics) = this.baseGameMask;
      }
    // }
      if (this.fgHitAnimationContainer) {
        this.fgHitAnimationContainer.x = this.fgHitAnimationContainer?.json?.lang[ingenuity.lang].x;
    }
  }

  /**
   * subscribeEvents method overrided to subscribe game end events
   */
  protected subscibeEvents() {
    super.subscibeEvents();
    dispatcher.on(eventDispatchers.RESET_SCATTER_DATA_FG, this.resetScatterSymbolDataFG, this);
    dispatcher.on(eventDispatchers.HIDE_POTION_LANDING_ANIM_FG, this.hidePotionLandingAnimFG, this);
  }

  /**
   * unsubscribeEvents method overrided to unSubscribe game end events
   */
  protected unsubscribeEvents(): void {
    super.unsubscribeEvents();
    dispatcher.off(eventDispatchers.RESET_SCATTER_DATA_FG, this.resetScatterSymbolDataFG, this);
    dispatcher.off(eventDispatchers.HIDE_POTION_LANDING_ANIM_FG, this.hidePotionLandingAnimFG, this);

  }

  /**
   * initializeComponents method overrided to initialize game end component
   */
  protected initializeComponents(): void {
    super.initializeComponents();
    this.freeSpinsText = this.getLabelById("freespinsLeftText") as Label;
  }

  /**
   * setReelView method overrided to add spine in reelview
   */
  public setReelView(reelView: ReelPanel, pos: any, parentId: any): void {
    super.setReelView(reelView, pos, parentId);
    this.addChildAt(this.getContainerByID("freegameBgSpineContainer"), 0);
    this.addChildAt(this.getImageById("gameLogo"), 4); // add gamelogo on top after removing winMtrFG
  }

  // Override to change if condition
  public landingAnimation(data: any) {
    const reelgrid: [][] = data[0];
    const reelview: ReelPanel = data[1];
    const reelId: number = data[2];
    for (let i: number = 0; i < reelgrid[reelId].length; i++) {
      if (this.json.reels.symbolData[reelgrid[reelId][i]].hasLanding) {
        const symbol: SymbolBase = reelview.getSymbolByPos(reelId, i);
        const staticSym: StaticSymbol = symbol.getStatic() as StaticSymbol;
        const animSym: SpineBase = symbol.getAnimation() as SpineBase;

        if (staticSym.name === gameConstants.FS_SYMBOL) {
          if (reelgrid[reelId][i] === gameConstants.FREE_SPIN_SYMBOL) {
            if (reelId === this.reelId_0 && this.scatterSymbolCount === this.scatterSymbol_0) {
              this.playScatterLandingAnim(staticSym, animSym, reelId);
            }
            else if (reelId === this.reelId_2 && this.scatterSymbolCount === this.scatterSymbol_1) {
              this.playScatterLandingAnim(staticSym, animSym, reelId);
            }
            else if (reelId === this.reelId_4 && this.scatterSymbolCount === this.scatterSymbol_2) {
              this.playScatterLandingAnim(staticSym, animSym, reelId);
            }
          }
        }

        //play landing animation for pot symbol
        if (reelgrid[reelId][i] === gameConstants.POT_SYMBOL && staticSym.name === gameConstants.POT_SYMBOL_NAME) {
          if (animSym) {
            const staticSymParent: IObject = staticSym.parent;
            if (staticSymParent) {
              staticSym.visible = false;
              animSym.visible = true;
              staticSymParent.addChild(animSym);
              animSym.playAnim("white_idle", false);
              animSym.onComplete.addOnce(() => {
                animSym.playAnim("white", false);
              }, this);
            }
          }
        }
      }
    }
  }

  /**
   * Method to reset scatter symbol count 
   */
  private resetScatterSymbolDataFG(): void {
    this.scatterSymbolCount = 0;
  }

  /**
   * Method to play scatter landing animation
   */
  private playScatterLandingAnim(staticSym: StaticSymbol, animSym: SpineBase, reelId: number): void {
    this.scatterSymbolCount = this.scatterSymbolCount + 1;
    const staticSymParent = staticSym.parent;
    if (staticSymParent && animSym) {
      (ingenuity.soundManager as any).playSound(SoundConstantGame.SCATTER_LANDING + (reelId), 1, false, gameConstants.SOUND_LIST_PRELOAD);
      staticSym.visible = false;
      animSym.visible = true;
      staticSymParent.addChild(animSym);
      animSym.playAnim("static", false);
      animSym.onComplete.addOnce(() => {
        animSym.playAnim("landing", false);
      }, this);
    }
  }


  /**
     * function is over rided to play spine animation for anticipation
     * initially the animation for anticipation was for sprite
     */
  public showAnticipation(reel: number, callback?: () => void, callbackScope?: any): void {
    if (typeof this.anticipationContainer === "undefined") {
      this.anticipationContainer = new Container(this.json, this.game);
      this.anticipationContainer.name = SlotConstants.AnticipationConatiner;
      this.addChild(this.anticipationContainer);
    }
    if (this.json.anticipationAnim) {
      const anticJson = this.json.anticipationAnim;
      anticJson.id = "anticipation";
      anticJson.type = "spine";
      const anticipation = this.createSpine(anticJson);
      if (anticipation) {
        anticipation.visible = true;
        this.anticipationContainer.addChild(anticipation);
        this.anticipationContainer.x = this.json.reels.reels[reel].x + this.json.reels.x + this.json.anticipationAnim.valueX;
        this.anticipationContainer.y = this.json.reels.reels[reel].y + this.json.reels.y + this.json.anticipationAnim.valueY;
        this.addChild(this.anticipationContainer);
        anticipation.playAnim("anticipation", true);
      }
    }
  }

  /**
   * clearAnticipation method remove anticipation tween
   */
  public clearAnticipation(): void {
    if (typeof this.anticipationContainer !== "undefined" && this.anticipationContainer.children[0]) {
      const fadeOutEffect: ITween = ingenuity.currentGame.add.tween(this.anticipationContainer.children[0]).to({ alpha: gameConstants.ALPHA_0 }, gameConstants.TIMER_200, Linear.None, true, 0, 0, false);
      fadeOutEffect.onComplete.addOnce(() => {
        ingenuity.currentGame.tweens.remove(fadeOutEffect);
        this.anticipationContainer.children[0] && this.anticipationContainer.removeChildAt(0);
      }, this);
    }
  }


  /**
   * clearAnticipation method overrided to update FreeSpinText
   */
  public UpdateFreeSpinCounterText(): void {
    super.UpdateFreeSpinCounterText()
    this.showFreeSpinText()
  }
  public updateNewAwardedFreespinsNumber(): void {
    super.updateNewAwardedFreespinsNumber();
    this.showFreeSpinText()
  }

  /**
   * showFreeSpinText method shows text according to free spins left
   */
  private showFreeSpinText(): void {
    this.remainingFreespin.visible = false;
    this.freeSpinsText.visible = true;
    let freeCounterText: string
    if (this.remainingFreespin.getValue() <= 1) {
      freeCounterText = this.remainingFreespin.getValue() + " " + ingenuity.currentGame.cache.getJSON("lang").free_Spin.text
    } else {
      freeCounterText = this.remainingFreespin.getValue() + " " + ingenuity.currentGame.cache.getJSON("lang").free_SpinsCount.text
    }
    if (ingenuity.deviceEnv.isDesktop) {
      this.freeSpinsText.setText(freeCounterText)
    } else {
      this.freeSpinsText.text = freeCounterText
    }
  }
  public resizeOrientation(e: IEvent) {
    this.storeLandscapeReelSize();//do not change order
    super.resizeOrientation(e);
    if (ingenuity.deviceEnv.getOrientation() !== detectDeviceEnvironmentConstants.constants.ORIENTATION.PORTRAIT) {
      this.scale.set(ingenuity.deviceEnv.getLandcapeMaxReelScale())
      this.y = (innerHeight * SlotConstantsBehavior.HALF_CONVERTER) + ((gameConstants.REEL_BOTTOM_SPACE / 2) * this.scale.x);
      if (!ingenuity.deviceEnv.isDesktop) {
        this.y = (innerHeight * SlotConstantsBehavior.HALF_CONVERTER) + ((gameConstants.REEL_BOTTOM_SPACE_LANDSCAPE / 2) * this.scale.x);
      }
    }
  }
  protected storeLandscapeReelSize(): void {
    gameConstants.REEL_WIDTH = this.getShapeById("freeGameLandscapeResizer").width;
    gameConstants.REEL_HEIGHT = this.getShapeById("freeGameLandscapeResizer").height;
  }
  protected addButtonPanelOnTop() {
    this.getContainerByID("portraitButtonsContainer") && ingenuity.currentGame.stage.addChild(this.getContainerByID("portraitButtonsContainer"));
    this.getContainerByID("topPortraitButtonsContainer") && ingenuity.currentGame.stage.addChild(this.getContainerByID("topPortraitButtonsContainer"));

    const buttonsContainer = this.getContainerByID("buttonsContainer");
    ingenuity.currentGame.stage.addChild(buttonsContainer);
    const buttonsContainerWidth = buttonsContainer.width;
    if (ingenuity.deviceEnv.getOrientation() === detectDeviceEnvironmentConstants.constants.ORIENTATION.LANDSCAPE) {
      buttonsContainer.pivot.set(ingenuity.configData.width / 2, 0);
      const scale = Math.min((window.innerHeight / ingenuity.configData.height), (window.innerWidth / ingenuity.configData.width));
      buttonsContainer.x = (buttonsContainer.width / 2) + ((window.innerWidth - buttonsContainerWidth) / 2);
      buttonsContainer.y = window.innerHeight - (this.getImageById("Button_Panel_Base").height * scale);
      buttonsContainer.scale.set(scale, scale);
    }
    else if (ingenuity.deviceEnv.getOrientation() === detectDeviceEnvironmentConstants.constants.ORIENTATION.PORTRAIT) {
      buttonsContainer.scale.set(this.portraitPanelSCaling());
      const bottomPanelBgPortrait = this.getImageById("Button_Panel_BasePort");
      bottomPanelBgPortrait && buttonsContainer.pivot.set(bottomPanelBgPortrait.width / 2, bottomPanelBgPortrait.height);
      buttonsContainer.x = window.innerWidth / 2;
      buttonsContainer.y = window.innerHeight;
    }

    dispatcher.fireEvent(eventDispatchers.ADD_TOP_BAR_ON_TOP);
  }

  /*
   Override to remove play landing sounds from here
   */
  protected checkAndPlayLandingSounds(evt: IEvent): void {

  }

  /**
   * This method is use to hide potion bag static symbol when its animation plays
   */
  private hidePotionLandingAnimFG(evt?: IEvent): void {
    const symbol: SymbolBase = this.getReelView().getSymbolByPos(evt.data[0], evt.data[1]);
    const staticSym: StaticSymbol = symbol.getStatic() as StaticSymbol;
    const animSym: SpineBase = symbol.getAnimation() as SpineBase;
    staticSym.visible = false;
    animSym.visible = false;
  }

  /**
 * Method overrided to update Orientation for Ipad
 */
  protected updateOrientation() {
    for (const key in this.allComponents) {
      if (this.allComponents.hasOwnProperty(key)) {
        const comp = this.allComponents[key];
        if (comp.json && comp.json.orientation) {
          this.updateProperties(comp, comp.json.orientation[ingenuity.deviceEnv.getOrientation()]);
        }
        if (ingenuity.deviceEnv.getIsIpad() && comp.json && comp.json.orientation && comp.json.orientation[ingenuity.deviceEnv.getOrientation() + SlotConstantsBehavior.IPAD]) {
          this.updateProperties(comp, comp.json.orientation[ingenuity.deviceEnv.getOrientation() + SlotConstantsBehavior.IPAD]);
        }
      }
    }
  }
  protected portraitPanelSCaling(): number {
    const viewHeight = (this.getShapeById("freeGameResizer").height / 2) * this.scale.x;
    let remainingHeight = (window.innerHeight / 2) - viewHeight;
    const portraitButtonContainerBg = this.getShapeById("portraitBackgroundShape");
    let availableScaling = this.scalingAvailable(remainingHeight, portraitButtonContainerBg);
    if (availableScaling > SlotConstantsBehavior.FLOATING_MAX_SCALE) {
      availableScaling = SlotConstantsBehavior.FLOATING_MAX_SCALE;
    }
    return availableScaling;
  }
  protected portraitHudOnResize() {
    if (ingenuity.deviceEnv.getOrientation() === deviceEnvironment.constants.ORIENTATION.PORTRAIT) {
      this.portraitButtonsContainer && this.onShowPortraitButtonpanel();
    }
    else {
      if (!ingenuity.deviceEnv.isDesktop) {
        this.onHidePortraitButtonPanel();
      }
    }

  }
  public onShowPortraitButtonpanel() {
    if (this.PortraitplayerMsgContainer && this.portraitButtonsContainer) {
      this.PortraitplayerMsgContainer.visible = true;
      this.PortraitplayerMsgContainer.y = this.getImageById("reelBGFg").y + this.getShapeById("freeGameResizer").height + SlotConstantsBehavior.PLAYER_MSSG_HEIGHT_SAFEAREA;
      dispatcher.fireEvent(SlotEventConstantsBehavior.ON_CHANGE_PLAYERMSG_PARENT);
      this.changeParent(this.portraitButtonsContainer);
      const portraitButtonContainerBg = this.getShapeById("portraitBackgroundShape");
      this.portraitButtonsContainer.scale.set(this.portraitPanelSCaling());
      let portraitButtonContainerBgHeight = (portraitButtonContainerBg.height * this.portraitButtonsContainer.scale.x);
      let meterPanelHeight = this.getImageById("Button_Panel_BasePort").height * this.getContainerByID("buttonsContainer").scale.x
      /**
       * to set portait button container y position to - bottom allign
      */
      this.portraitButtonsContainer.pivot.set(ingenuity.configData.width / 2, 0);
      this.portraitButtonsContainer.x = window.innerWidth / 2;
      this.portraitButtonsContainer.y = window.innerHeight - (portraitButtonContainerBgHeight + meterPanelHeight);
      this.portraitButtonsContainer.alpha = 1;
    }
  }
}
